import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bot-sy",
  "use": "icon-bot-sy-usage",
  "viewBox": "0 0 48.006 43.25",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48.006 43.25\" id=\"icon-bot-sy\">\r\n  <defs>\r\n    <style>\r\n      #icon-bot-sy .cls-1 {\r\n        fill: #999;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <g id=\"icon-bot-sy_首页\" transform=\"translate(-69 -180.75)\">\r\n    <path id=\"icon-bot-sy_首页-2\" data-name=\"首页\" class=\"cls-1\" d=\"M47.4,19.8,27.1,3.8a5.1,5.1,0,0,0-6.2,0L.6,19.8A1.6,1.6,0,0,0,.3,22a1.579,1.579,0,0,0,2.2.3l.6-.5V41.2C3.1,43.9,6,46,8.5,46h32c2.5,0,4.2-1.9,4.2-4.8V21.9l.6.4a1.929,1.929,0,0,0,1,.3,1.76,1.76,0,0,0,1.3-.6,1.5,1.5,0,0,0-.2-2.2Zm-25,23V33.9c0-.4.8-.7,1.6-.7s1.6.2,1.6.7v8.9Zm19.2-1.6c0,1.1-.3,1.6-1,1.6H28.8V33.9C28.8,32,27.3,30,24,30s-4.8,2-4.8,3.9v8.9H8.6c-1,0-2.2-.9-2.2-1.6V19.3l16.4-13a1.8,1.8,0,0,1,2.2,0L41.5,19.4l.1,21.8Zm0,0\" transform=\"translate(69.012 178)\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/bot-sy.svg
// module id = hPEo
// module chunks = 3